<template>
    <div class="app_container">
        <el-form :rules="rules" ref="form" :model="form" label-width="80px" class="inspection_form">
            <!--标题-->
            <el-row>
                <el-col :span="12">
                    <el-form-item label="标题" prop="title">
                        <el-input type="text" placeholder="请输入标题" v-model="form.title" class="form-input"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--巡检对象-->
            <el-row>
                <el-col :span="12">
                    <el-form-item label="巡检对象">
                        <!-- <el-button type="primary" class="iconfont icon-gengduo icon" @click='dialogFormVisible = true'></el-button> -->
                            <router-link :to="{ path:'/addConfiguration',query: { callback:relevancyConfig} }">
                                <el-button type="primary" class="iconfont icon-gengduo icon"></el-button>
                            </router-link>
                            <relevancy-tab :data="toCmdb" :getData="getCmdbData"></relevancy-tab>

                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="18">
                    <el-form-item label="处理组" prop="handlerGroup">
                        <div>
                            <el-select v-model="form.handlerGroup" filterable placeholder="请选择"
                                       class="form-input mr10"
                                       @change="departmentChange">
                                <el-option v-for="item in departmentList" :key="item.id" :label="item.name"
                                           :value="item.id"></el-option>
                            </el-select>
                            <el-button :type="groupTasksTotal>=5?'danger':'success'" plain  >组繁忙度  ({{groupTasksTotal}})</el-button>

                        </div>
                    </el-form-item>
                </el-col>

            </el-row>
            <el-row>
                <el-col :span="18">
                    <el-form-item label="处理人" prop="currentHandler">
                        <div>
                            <el-input v-model="form.currentHandler.name" disabled class="form-input mr10"></el-input>
                            <el-button  type="primary" class="iconfont icon-gengduo icon" :disabled="form.handlerGroup?false:true" @click="toRequesterList"></el-button>
                            <el-button type="primary" :type="userTasksTotal>=5?'danger':'success'" plain >人员繁忙度  ({{userTasksTotal}})</el-button>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="时间类型" prop="timeType">
                        <el-select v-model="form.timeType" placeholder="请选择" class="form-input">
                            <el-option v-for='item in timeTypeList' :key="item.id" :value="item.ename" :label="item.cname"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--时间选择-->
            <el-row>
                <el-col :span="12" style="margin-left:-10px">
                    <el-form-item label="时间选择" label-width="90px">
                        <!--每周计划时选取星期几-->
                        <el-form-item v-if="form.timeType=='weekly'" >
                            <el-checkbox  v-model="checkWeeksAll" @change="handleCheckAllWeeksChange">全选</el-checkbox>
                            <div style="margin: 15px 0;"></div>
                            <el-checkbox-group v-model="checkedWeeks" @change="handleCheckedWeeksChange">
                                <el-checkbox v-for="item in weekDays" :label="item.id" :key="item.id" >{{item.week}}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <!--每月计划时选取月份-->
                        <el-form-item v-if="form.timeType=='monthly'" >
                            <el-checkbox  v-model="checkMonthsAll" @change="handleCheckAllMonthsChange">全选</el-checkbox>
                            <div style="margin: 15px 0;"></div>
                            <el-checkbox-group v-model="checkedMonths" @change="handleCheckedMonthsChange">
                                <el-checkbox v-for="item in month" :label="item.id" :key="item.id" >{{item.month}}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <!--生成一次时选择日期时间-->

                        <el-date-picker
                                v-model="inspectionTimeOnce"
                                type="datetime"
                                placeholder="选择日期时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                v-if="form.timeType==='once'"
                                class="form-date-input" >
                        </el-date-picker>


                        <!--每日计划时选取时间-->
                        <el-time-picker
                                v-model="inspectionTimeDaily"
                                placeholder="任意时间点"
                                value-format="HH:mm:ss"
                                v-if="form.timeType==='daily'"
                                class="form-date-input"
                            >
                        </el-time-picker>


                        <!--每周计划时选取时间-->
                        <el-time-picker
                            v-model="inspectionTimeWeekly"
                            placeholder="任意时间点"
                            value-format="HH:mm:ss"
                            v-if="form.timeType==='weekly'"
                            class="form-date-input"

                        >
                        </el-time-picker>
                       <!--每月计划时选取每月的某天-->
                        <el-select v-model="inspectionDay"
                                   placeholder="天" class="inspection-day form-date-input"
                                   v-if="form.timeType==='monthly'"
                                   prop="day">
                            <el-option
                                v-for="item in days"
                                :key="item.id"
                                :label="item.day"
                                :value="item.day"

                            >
                            </el-option>
                        </el-select>
                        <!--每月计划时选取时间-->
                        <el-time-picker
                            v-model="inspectionTimeMonthly"
                            placeholder="任意时间点"
                            value-format="HH:mm:ss"
                            v-if="form.timeType==='monthly'"
                            class="form-date-input"

                        >
                        </el-time-picker>

                    </el-form-item>
                </el-col>
            </el-row>


            <el-form-item>
                <el-button type="primary" size="small" @click="submit">确定</el-button>
                <el-button type="default" size="small" @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
        <!-- <el-dialog title="选择配置项" :visible.sync="dialogFormVisible">
         <div slot="footer" class="dialog-footer">
            <inspectdialog></inspectdialog>
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
          </div>
        </el-dialog> -->
    </div>
</template>

<script>
    import inspectdialog from '../../components/addConfiguration/index';
    import inputFile from "../common/inputFile.vue"
    import services from './inspection.service'
    import relevancyTab from "../common/relevancyTab.vue"
    import {weekOptions,weekIds,monthOptions,monthIds,days} from './inspection.config'

    import { getRules } from "./inspection.rules";
    const rules = getRules();
    export default {
        components:{inspectdialog},
        props:{
          callback:Function,
            type:{
                type:String,
                default:''
            },
            id:Number
        },
       data(){
           return{
               dialogFormVisible:false,
               formName:"form",
               rules:rules,
               form:{
                   title:'',   //标题
                   timeType:'', //时间类型
                   // timeSchedule:'',

                   handlerGroup:'',
                   currentHandler:'',

               },
               timeSchedule:'',
               toCmdb:[],
               dis_user:true,
               departmentList:[],      // 处理组
               requesterInfo:{},
               groupTasksTotal:'',   //组任务数
               userTasksTotal:'',    //人员任务数量

               inspectionTimeOnce:'',  //生成一次时间
               inspectionTimeDaily:'',  //每日计划时间
               inspectionTimeWeekly:'',  //每周计划时间
               inspectionTimeMonthly:'',  //每月计划时间
               inspectionDay:'',         //每月计划具体天
               checkWeeksAll: false,
               checkMonthsAll:false,
               checkedWeeks: [],
               checkedMonths:[],
               complexTime:{},   //选取每周每月时的时间格式
               weekDays: weekOptions,
               month:monthOptions,
               weekIds,
               monthIds,
               days,
               // isLeap:null              //是否是闰年
           }
       },
        computed:{
            dictionary(){
                return this.$store.state.dictionary
            },
            //时间类型
            timeTypeList(){
                return this.dictionary.inspect_time_type
            }
        },
        created(){
            // console.log(this.dictionary,'字典');
            // console.log(days);
            this.getDepartment();
            if (this.type=='edit') {
                this.getDetail()
            }
        },
        components:{inputFile,relevancyTab},
        methods:{

            // 服务组
            getDepartment(){
                services.getDepartmentList().then(res => {
                    this.departmentList = res.list;
                    // console.log(this.departmentList,'departmentList');
                })
            },
            departmentChange(){
                // console.log('?');
                this.dis_user = this.form.handlerGroup ? false : true;
                this.requesterInfo = {
                    id:"",
                    name:"",
                };
                this.form.currentHandler = "";
                // this.busynessUserbtn = this.requesterInfo.id ? false : true;
                let groupId=this.form.handlerGroup
                this.getGroupBusyness(groupId)
            },
            getGroupBusyness(id){
                services.busynessGroup(id).then(res => {
                    this.groupTasksTotal = res.tasksTotal;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            // 组员页面
            toRequesterList(){
                let id = this.form.handlerGroup.toString();
                this.$router.push({
                    path: '/appointUser',
                    name: "appointUser",
                    query: {
                        callback:this.getRequester,
                        id:id
                    }
                })
            },
            getRequester(obj){
                this.requesterInfo = {
                    id:obj.internalUserid,
                    name:obj.name,
                };
                this.form.currentHandler = obj;
                // this.busynessUserbtn = obj.internalUserid ? false : true;
                let userid=this.requesterInfo.id
                this.getUserBusyness(userid)
            },
            getUserBusyness(id){
                services.busynessUser(id).then(res => {
                    this.userTasksTotal= res.tasksTotal;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },

           //上传文件
            getFiles(val){
                this.attachment = val;
            },
            getDetail(){
                // console.log(this.id,'id');
                services.getDetail({ id:this.id}).then(res => {
                    this.detailSuccessFn(res);
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            //获取详情后数据处理
            detailSuccessFn(res){
                this.form=res
                this.form.handlerGroup=this.form.handlerGroup.id
                this.toCmdb=this.form.cmdb
                this.requesterInfo.id=this.form.currentHandler.userid

                let userid=this.requesterInfo.id
                this.getUserBusyness(userid)
                let groupId=this.form.handlerGroup
                this.getGroupBusyness(groupId)
                //判断时间类型去选择匹配不同的值
                switch (this.form.timeType) {
                    case 'once':
                        this.inspectionTimeOnce=this.form.timeSchedule
                        break
                    case 'daily':
                        this.inspectionTimeDaily=this.form.timeSchedule
                        break
                    case 'weekly':
                        // this.inspectionTimeWeekly=this.form.timeSchedule
                        this.handleTime(this.form.timeSchedule)
                        break
                    case 'monthly':
                        // this.inspectionTimeMonthly=this.form.timeSchedule
                        // this.handleTime(this.inspectionTimeMonthly)
                        this.handleTime(this.form.timeSchedule)
                        break
                }
                // console.log(this.checkedMonths);
                // console.log(typeof this.inspectionTimeMonthly);
                // console.log(this.checkedMonths);
                // this.handleTime(this.inspectionTimeMonthly)
            },
            //获取详情里的复杂时间格式处理
            handleTime(timeVal){
                // console.log(this.inspectionTimeMonthly);
                // console.log(timeVal);
                let timeObj = JSON.parse(timeVal)
                // console.log(timeObj);
                if (this.form.timeType=='weekly') {

                    let keyArr=Object.keys(timeObj)
                    let anyKey=keyArr[0]
                    //要获取传回来的时间格式中的时间类型，赋予this.inspectionTimeWeekly
                    this.inspectionTimeWeekly=timeObj[anyKey].slice(0)
                    for (let key in timeObj) {
                        this.checkedWeeks.push(key)
                    }
                    this.checkWeeksAll=this.checkedWeeks.length===this.weekIds.length
                }else{
                    let keyArr=Object.keys(timeObj)
                    let anyKey=keyArr[0]
                    //要获取传回来的时间格式中的时间类型，赋予this.inspectionTimeMonthly
                    this.inspectionTimeMonthly=timeObj[anyKey].slice(6)
                    //获取传回来的时间格式中的具体日期，赋予this.inspectionDay
                    this.inspectionDay=timeObj[anyKey].slice(3,5)
                    // console.log(this.inspectionTimeMonthly,'获取每月详情时时间选择器绑定值');
                    for (let key in timeObj){
                            this.checkedMonths.push(key)
                    }
                    this.checkMonthsAll=this.checkedMonths.length===this.monthIds.length
                }
                // console.log(aa);
            },
            //提交按钮
            submit(){
                let formName=this.formName
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        switch (this.form.timeType) {
                            case 'once':
                                this.validateTime('once')
                                break
                            case 'daily':
                                this.validateTime('daily')
                                break
                            case 'weekly':
                                this.validateTime('weekly')
                                break
                            case 'monthly':
                                this.validateTime('monthly')
                                break
                        }

                    }
                })


            },
            validateTime(val){
                if (val=='once'){
                    if (Boolean(this.inspectionTimeOnce)==false){
                        this.$message.error('请选择时间')
                    } else{
                        this.sendMes()
                    }
                }
                if (val=='daily'){
                    if (Boolean(this.inspectionTimeDaily)==false){
                        this.$message.error('请选择时间')
                    } else{
                        this.sendMes()
                    }
                }
                if (val=='weekly'){
                    if (this.checkedWeeks.length==0||Boolean(this.inspectionTimeWeekly)==false){
                        this.$message.error('星期或时间不能为空')
                        // console.log(Boolean(this.inspectionTimeWeekly));
                        //用Boolean是为了判断若时间组件点击“×”，则绑定数据变成了null而不是初始的''，null与
                        //''的布尔值均为false，不这么判断的话会造成往后端传递null
                    } else {
                        // console.log('one');
                        this.sendMes()
                    }
                }
                if (val=='monthly'){
                    if (this.checkedMonths.length==0||Boolean(this.inspectionTimeMonthly)==false||Boolean(this.inspectionDay)==false){
                        this.$message.error('星期或时间或日期不能为空')
                    } else {
                        this.sendMes()
                    }
                }


            },
            sendMes(){
                this.getCorrectTime()
                let params = this.getParams();
                if (this.type == 'edit') {
                    // console.log(this.inspectionTimeWeekly);
                    this.updateInspect(params)
                } else {
                    this.addInspect(params)
                }
            },
            getParams(){
                let cmdbSn=this.toCmdb.map(item=>{
                    return item.serialNumber
                })
                // console.log(cmdbSn,'cmdbSn');
                switch (this.form.timeType) {
                    case 'once':
                        this.timeSchedule=this.inspectionTimeOnce
                        break
                    case 'daily':
                        this.timeSchedule=this.inspectionTimeDaily
                        break
                    case 'weekly':
                        this.timeSchedule=JSON.stringify(this.complexTime)
                        break
                    case 'monthly':
                        // console.log(this.complexTime,'提交时的complexTime');
                        this.timeSchedule=JSON.stringify(this.complexTime)
                        break
                }
                return{
                    ...this.form,
                    // handlerGroup:this.form.handlerGroup.id,
                    cmdbSerialNumber:cmdbSn,
                    currentHandler: this.requesterInfo.id,
                    timeSchedule:this.timeSchedule
                }
            },
            updateInspect(params){
                services.updateInspection(params).then(res=>{
                    this.$message.success("巡检修改成功");
                    this.close(true);
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            addInspect(params){
                services.addInspection(params).then(res=>{
                    this.$message.success("巡检新增成功");
                    this.close(true);
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            getCorrectTime(){
                // console.log('two');
                if (this.form.timeType=='weekly'){
                    let arr=this.checkedWeeks
                    let timeWeekly=this.inspectionTimeWeekly
                    arr.forEach((item)=>{
                        this.complexTime[item]=timeWeekly
                    })
                } else{
                    // console.log(this.checkedMonths);
                    let arr=this.checkedMonths
                    for (let i=0,len=arr.length;i<len;i++){
                        let correctDay=this.inspectionDay
                        if (arr[i]==='04'||arr[i]==='06'||arr[i]==='09'||arr[i]==='11') {
                            if (correctDay==31) {
                                // console.log('小月没有31');
                                correctDay-=1
                            }
                        }else if (arr[i]==='02'){
                            if (correctDay>28){
                                correctDay=28
                                // console.log('二月没有29');
                            }
                        }
                        this.complexTime[arr[i]]=`${arr[i]}-${correctDay} ${this.inspectionTimeMonthly}`
                    }
                }

                // let curTime=new Date()
                // let year=curTime.getFullYear()
                // this.isLeap = year % 4 == 0 && year % 100 != 0 || year % 400 == 0;
                return this.complexTime
            },
            handleCheckAllWeeksChange(val) {
                this.checkedWeeks = val ? weekIds : [];

            },
            handleCheckAllMonthsChange(val) {
                this.checkedMonths = val ? monthIds : [];

            },

            handleCheckedWeeksChange(value) {
                // console.log(value,'每次选择星期几时触发的函数');
                // console.log(this.checkedWeeks);
                // console.log(this.checkedWeeks,'weekly选取星期几');
                let checkedCount = value.length;
                this.checkWeeksAll = checkedCount === this.weekDays.length;
            },
            handleCheckedMonthsChange(value){
                // console.log(value,'每次选择月份时触发的函数，checkedMonths');
                let checkedCount = value.length;
                this.checkMonthsAll = checkedCount === this.month.length;
            },
            //选择完关联项后去重，此方法可通用于包含对象的数组深层次去重
            arrayUnique(arr){
                let obj={}
                let newArr = []
                arr.forEach(item=>{
                    if(!obj[item.serialNumber]){
                        obj[item.serialNumber]=1
                        newArr.push(item)
                    }
                })
                return newArr
            },
            //获取选择后的关联的配置项
            relevancyConfig(val){
                // console.log(val);
                this.toCmdb=this.arrayUnique(this.toCmdb.concat(val))
                // console.log(this.toCmdb,'this.form.toCmdb');
                // val.forEach(item => {
                //     this.toConfigName.push(item.title);
                //     this.toConfigId.push(item.serialNumber);
                // });
            },
            getCmdbData(val){ this.toCmdb = val;},
            //取消按钮
            onCancel(){
                this.close();
            },
            //取消后关闭页面
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },
        }
    }
</script>

<style scoped type="SCSS">
    .el-form__inline{
        width:100%;
        display: flex;
    .icon{
        margin-left: 20px;
    }
    .el-input{
        flex:1;
    }
    }
    .inspection-day{
        width: 60px;
    }
</style>
